import { topMakesAvto } from 'shared/constants/topMakes';

const getTop = (allItems, topItemsId) =>
  allItems
    .filter(item => topItemsId.includes(item.id))
    // Need a unique id in order for react-select to work properly
    .map(item => ({ ...item, uniqueId: `top-${item.id}` }))
    .sort((a, b) => (a.title < b.title ? -1 : 1));

const getItemsWithUniqueIds = (allItems, topItemsId) =>
  allItems
    .filter(item => !topItemsId.includes(item.id))
    .sort((a, b) => (a.title < b.title ? -1 : 1));

export const injectTopMakesToOptions = (makes, intl) => {
  const safeMakes = makes ? [...makes] : [];
  let anyItem = [];
  const any = safeMakes.findIndex(item => item.id === -1);
  if (any >= 0) {
    anyItem = safeMakes.splice(any, 1);
  }
  const topMakes = getTop(safeMakes, topMakesAvto);
  const makesWithUniqueIds = getItemsWithUniqueIds(safeMakes, topMakesAvto);

  return [
    ...anyItem,
    ...(topMakes.length > 0
      ? [
          {
            title: intl.formatMessage({ id: 'Топ марки' }),
            disabled: true,
          },
          ...topMakes,
          {
            title: intl.formatMessage({ id: 'Остальные марки' }),
            disabled: true,
          },
        ]
      : []),
    ...makesWithUniqueIds,
  ];
};

export const injectTopModelsToOptions = (models, intl, topModelsAvto) => {
  const safeModels = models || [];
  const topModels = getTop(safeModels, topModelsAvto);
  const modelsWithUniqueIds = getItemsWithUniqueIds(safeModels, topModelsAvto);

  return [
    ...(topModels.length > 0
      ? [
          {
            title: intl.formatMessage({ id: 'Топ модели' }),
            disabled: true,
          },
          ...topModels,
          {
            title: intl.formatMessage({ id: 'Остальные модели' }),
            disabled: true,
          },
        ]
      : []),
    ...modelsWithUniqueIds,
  ];
};

export const skipTopMakes = (option, filter) => {
  if (!option.title) {
    return false;
  }

  return option.title.toLowerCase().startsWith(filter);
};



// WEBPACK FOOTER //
// ./src/shared/components/SearchPanel/transformOptions.js